var dropdownSubItem = 'fx_2d2fb1e5_qv53bn0';

export { dropdownSubItem };
//# sourceMappingURL=subItem.vanilla.mjs.map
